import { TableHeader } from "components/TableHeader/TableHeader";

export const HeaderRow = () => {
  const elements = [
    {
      label: "Nume",
      withoutBorder: true,
    },
    {
      label: "Email",
    },
    {
      label: "Rol",
    },
    {
      label: "ID entitate",
    },
    {
      label: "Actiuni",
    },
  ];
  return <TableHeader elements={elements} />;
};
